import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F1AC7C0E-CA03-4ED0-AFE9-CE0CEB3C9806
 * name transmission-tower-export
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/transmission-tower-export.svg
 * tags
 * - Home Automation 
 */
export const TransmissionTowerExportIcon = createSvgIcon(<><path d="M5.18 5.45L3.4 4.55L4.66 2H13.13L14.4 4.55L12.62 5.44L11.9 4H5.9L5.18 5.45M15.5 8H11L10.2 5H7.6L6.81 8H2.28L1 10.55L2.79 11.44L3.5 10H14.28L15 11.45L16.79 10.56L15.5 8M14.67 22H12.6L12.36 21.1L8.9 15.9L5.43 21.1L5.2 22H3.13L6 11H8.09L7.73 12.35L8.9 14.1L10.06 12.35L9.71 11H11.78L14.67 22M8.3 15L7.4 13.65L6.22 18.13L8.3 15M11.58 18.12L10.4 13.64L9.5 15L11.58 18.12M23 16L19 12V15H15V17H19V20L23 16Z" /></>, 'TransmissionTowerExportIcon');
export default TransmissionTowerExportIcon